import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Product } from 'src/app/classes/utility';
import { MercuryService } from 'src/app/service/mercury.service';
import { AccordionComponent } from 'src/app/snippet/accordion/accordion.component';
import { WishlistComponent } from '../../../../snippet/wishlist/wishlist.component';
import { AddToCartComponent } from './add-to-cart/add-to-cart.component';
import { BadgeComponent } from './badge/badge.component';
import { PriceComponent } from './price/price.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { VariantPickerComponent } from './variant-picker/variant-picker.component';

@Component({
  selector: 'app-meta',
  standalone: true,
  imports: [
    PriceComponent,
    WishlistComponent,
    BadgeComponent,
    ReviewsComponent,
    VariantPickerComponent,
    AddToCartComponent,
    AccordionComponent,
    NgFor,
    NgIf,
    NgClass,
  ],
  templateUrl: './meta.component.html',
  styleUrl: './meta.component.scss',
})
export class MetaComponent implements OnChanges {
  @Input() product!: Product;
  badge: string | undefined = undefined;
  accordions: any;
  _description: any;

  constructor(private mercuryService: MercuryService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.badge = this.product?.tags
      .split(',')
      .find((x) => x.includes('badge:'))
      ?.split(':')[1];
    this.accordions = [
      this.product.metafields?.info?.short_description && {
        title: 'Description',
        content: this.product.body_html,
      },
      this.product.metafields?.accordion?.specifications && {
        title: 'Specifications',
        content: this.mercuryService.convertToHtml(
          this.product.metafields.accordion.specifications
        ),
      },
      this.product.metafields?.accordion?.inclusions && {
        title: 'Inclusions',
        content: this.mercuryService.convertToHtml(
          this.product.metafields.accordion.inclusions
        ),
      },
      {
        title: 'Shipping',
        content:
          '<p>Free Australian <a href="/pages/shipping-and-returns">shipping</a> on all orders over $25AUD. You can purchase express shipping at checkout.</p>',
      },
    ].filter((x) => x?.title !== undefined);
    if (this.product.metafields?.info?.short_description) {
      this._description = this.mercuryService.convertToHtml(
        this.product.metafields.info.short_description
      );
    }
  }
}
